module.exports = __webpack_public_path__ + "static/josh8-c8541c1265a4f04eb1e3d5ad3c63a117.jpg";